import { render } from "./AddToHome2.vue?vue&type=template&id=07908591"
import script from "./AddToHome2.vue?vue&type=script&lang=js"
export * from "./AddToHome2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__